module.exports = __webpack_public_path__ + "public/img/logo.03996b69.png";